<template>
    <div class="container">
        <div class="modify consent">
            <h3 class="modify__title text-center">Modificare Consimtamant</h3>
            <div class="row">
                <div class="modify__container mt-2 col-12 col-sm-6 col-md-4" v-for="(item, index) in consent" :key="index">
                    <div class="modify__form-title"> {{ item.form_type }} </div>
<!--
                    <div class="form-check">
                        <input class="form-check-input" type="checkbox" :id="'confidential' + index" v-model="fields[item.form_type].confidential_policy">
                        <label class="form-check-label" :for="'confidential' + index">Politica Confidentialitate</label>
                    </div> 
                    <div class="form-check">
                        <input class="form-check-input" type="checkbox" :id="'terms' + index" v-model="fields[item.form_type].terms_and_conditions">
                        <label class="form-check-label" :for="'terms' + index">Termeni si Conditii</label>
                    </div>                 
-->
                    <div class="form-check">
                        <input class="form-check-input" type="checkbox" :id="'comercial' + index" v-model="fields[item.form_type].comercial_offer">
                        <label class="form-check-label" :for="'comercial' + index">Oferta Comerciala</label>
                    </div> 
                    <div class="form-check">
                        <input class="form-check-input" type="checkbox" :id="'promotions' + index" v-model="fields[item.form_type].promotions">
                        <label class="form-check-label" :for="'promotions' + index">Promotii</label>
                    </div> 
                </div>               
            </div>
            <div class="success text-success mt-3 text-center" v-if="successMessage !== ''">
                <p class="success__text mb-1"> {{ successMessage }} </p>
            </div>
            <div class="consent__btn-container mt-3">
                <button class="btn btn-primary call-to__button modify__button" @click.prevent="sendData">Trimite</button>
            </div> 
        </div>
    </div>
</template>

<script>
    export default {
        data () {
            return {
                consent: {
                    
                },
                fields: {
                    
                },
                successMessage: ''
            }
        },
        created () {
            this.getConsents()  
        },
        methods: {
            getConsents () {
                this.$http.get(`/showconsents/${this.$route.params.hash}`)
                .then(response => {
                    this.consent = response.data
                    this.makeFields()
                })
                .catch(e => {
                    console.log(e)
                    this.$router.push('/404')
                })
            },
            makeFields () {
                for (let i = 0; i < this.consent.length; i++) {
                    this.fields[this.consent[i].form_type] = {}
                    this.fields[this.consent[i].form_type]['id'] = this.consent[i].id
                    this.fields[this.consent[i].form_type]['name'] = this.consent[i].form_type
//                    this.fields[this.consent[i].form_type]['confidential_policy'] = this.consent[i].confidential_policy
//                    this.fields[this.consent[i].form_type]['terms_and_conditions'] = this.consent[i].terms_and_conditions
                    this.fields[this.consent[i].form_type]['comercial_offer'] = this.consent[i].comercial_offer
                    this.fields[this.consent[i].form_type]['promotions'] = this.consent[i].promotions
                }
            },
            sendData () {
                for (let i in this.fields) {
                    this.$http.put(`/consent/${this.fields[i].id}`, {
                        ...this.fields[i]
                    }).then(response => {
                        if(response.status == 200) {
                            this.successMessage = 'Datele au fost actualizate cu succes!'
                            setTimeout(() => {this.successMessage = ''}, 3000)
                        }
                    }).catch(e => console.log(e))
                }
            }
        }
    }
</script>